<div class="estimation-table">
  <div class="project-header">
    <h4>{{projectName}}</h4>
     <div class="project-info">
      <div class="total-estimated-container">
        <span nz-icon nzType="dollar" class="dolar-icon"></span>
        <span class="total-estimated">Total estimado por pag. seleccionada:</span> 
        <h2>{{estimatedTotal | currency:'':'$':'1.2-2':'en-US'}}</h2>
        <span class="currency">MX</span>
      </div>
       <div class="project-info-buttons">
        <button nz-button nzType="text" (click)="onFilterByProvider()">
          <span nz-icon nzType="filter"></span>
          <span>
            Filtrar por proveedor
          </span>
        </button>
        <div class="export-and-columns">
          <button nz-button nzType="default" nz-dropdown [nzDropdownMenu]="exportMenu"
            nzTrigger="click" [disabled]="!canPrint"
            nz-tooltip nzTooltipTitle="Exportar a excel">
            <span nz-icon nzType="file-excel"></span>
          </button>
          <button nz-button nzType="default" nz-dropdown
            class="show-columns-button"
            [nzDropdownMenu]="columnsMenu" [nzClickHide]="false"
            nzTrigger="click" nzOverlayClassName="columns-menu-dropdown">
            <img src="assets/InsertColumnAboveOutlined.svg">
           </button>
        </div>
       </div>
     </div>
  </div>
  <nz-dropdown-menu #exportMenu="nzDropdownMenu">
    <ul nz-menu class="columns-menu-container">
      <li nz-menu-item>
        <!-- <a href="/api/export/estimations?project_id={{projectId}}" target="_blank">
          <span nz-icon nzType="file-excel" nzTheme="fill"></span>
          <span>Exportar toda la data en excel</span>
        </a> -->
      </li>
      <!-- <li nz-menu-item>
        <span nz-icon nzType="file-excel" nzTheme="outline"></span>
        <span>Exportar celdas seleccionadas a excel</span>
      </li> -->
    </ul>
  </nz-dropdown-menu>
  <nz-dropdown-menu #columnsMenu="nzDropdownMenu">
    <label class="column-selector">Selector de columnas</label>
    <input type="text" nz-input placeholder="Buscar columna" (input)="onFilterColumnsList($event)" />
    <ul nz-menu nzSelectable class="columns-menu-container">
      @for(column of estimationCheckableColumnsList; track column.title) {
        @if (column.hasShowAndHideColumnFilter) {
          <li nz-menu-item>
            <label nz-checkbox [(ngModel)]="column.isVisible"
              [disabled]="column.title === 'ID Descripción'">{{column.title}}</label>
          </li>
        }
      }
    </ul>
  </nz-dropdown-menu>
  <nz-tabset [nzTabBarExtraContent]="clearAllFilters" [nzSelectedIndex]="currentTab">
    @for (tab of estimationTabsList; track $index; let tabIndex = $index) {
    <nz-tab nzTitle={{tab}} (nzClick)="onChangeEstimationTab(tabIndex)">
      <nz-table #sortTable [nzData]="estimationTableData" nzTableLayout="fixed" [nzNoResult]="emptyEstimations"
        [nzScroll]="{ x: '950px' }" nzShowPagination="false" [nzLoading]="loading" [nzPageSize]="pageSize"
        [nzTotal]="totalEstimations">
        <thead>
          <tr>
            <th nzWidth="50px" nzAlign="center">
              <label nz-checkbox (nzCheckedChange)="onSelectAllEstimations()" [(ngModel)]="areAllEstimationsSelected"
                [nzDisabled]="estimationTableDataBackup.length === 0"></label>
            </th>
            @for (column of estimationColumnsList; track column.name; let i = $index) {
              @if (column.isVisible) {
                <th [nzWidth]="column.width" [nzAlign]="column.align === 'center' ? 'center'
                                          : column.align === 'right' ? 'right'
                                          : column.align === 'left' ? 'left'
                                          : null" style="white-space: pre-line;">
                  <div class="column-header">
                    {{ column.title }}
                    @if (column.isSortable) {
                      <div class="sort-buttons">
                        <button class="sort-button" nz-button nzType="text" (click)="onSortColumn(column.name!)">
                          <span
                            [ngStyle]="(selectedSortColumn === column.name && selectedSortDirection === 'asc')
                              ? {color: '#69c0ff'}
                              : {color: ''}"
                            nz-icon nzType="caret-up" nzTheme="outline"></span>
                          <span
                            [ngStyle]="(selectedSortColumn === column.name && selectedSortDirection === 'desc')
                            ? {color: '#69c0ff'}
                            : {color: ''}"
                            nz-icon nzType="caret-down" nzTheme="outline"></span>
                        </button>
                      </div>
                    }
                  </div>
                </th>
              }
            }
          </tr>
          <tr>
            <th></th>
            @for (filter of estimationColumnsList; track filter.name; let estimationIndex = $index) {
              @if (filter.hasSearchFilter && filter.isVisible) {
                <th nzAlign="right">
                  @if (filter.name === 'providerName' && usersInEstimations && usersInEstimations.userWhoBuys) {
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoBuys">
                    @for (user of usersInEstimations.userWhoBuys; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'userWhoRequests' && usersInEstimations &&
                  usersInEstimations.userWhoRequests) {
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoRequests">
                    @for (user of usersInEstimations.userWhoRequests; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'userWhoReviews' && usersInEstimations && usersInEstimations.userWhoReviews){
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoReviews">
                    @for (user of usersInEstimations.userWhoReviews; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'userWhoAuthorizes' && usersInEstimations &&
                  usersInEstimations.userWhoAuthorizes) {
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoAuthorizes">
                    @for (user of usersInEstimations.userWhoAuthorizes; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'estimationKey') {
                    <span>{{selectedIdFilter}}</span>                  
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedIdFilter"
                        [nzDropdownMenu]="idFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowIdFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #idFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onIdFilterChange(selectedIdFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedIdFilter"
                            name="id" #idInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                              class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetIdFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'estimationFolio') {
                    <span>{{selectedFolioFilter}}</span>                  
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedFolioFilter"
                        [nzDropdownMenu]="folioFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowFolioFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #folioFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onFolioFilterChange(selectedFolioFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedFolioFilter"
                            name="folio" #folioInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                              class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetFolioFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'estimationDescription') {
                    <span>{{selectedDescriptionFilter}}</span>                  
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedDescriptionFilter"
                        [nzDropdownMenu]="descriptionFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowDescriptionFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #descriptionFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onDescriptionFilterChange(selectedDescriptionFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedDescriptionFilter"
                            name="description" #descriptionInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                              class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetDescriptionFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'project') {
                    <span>{{selectedProjectFilter}}</span>                  
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedProjectFilter"
                        [nzDropdownMenu]="projectFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowProjectFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #projectFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onProjectFilterChange(selectedProjectFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedProjectFilter"
                            name="project" #projectInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                              class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetProjectFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'totalCost') {
                    <span>{{selectedTotalCostFilter !== null ? selectedTotalCostFilter : ''}}</span>               
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedTotalCostFilter"
                        [nzDropdownMenu]="totalCostFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowTotalCostFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #totalCostFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="net-amount search-box"
                          (ngSubmit)="onTotalCostFilterChange(selectedTotalCostFilterType!, selectedTotalCostFilter!)">
                          <nz-select class="filter-input"
                            nzPlaceHolder="Tipo de filtro"
                            name="totalCostType" #totalCostType
                            [(ngModel)]="selectedTotalCostFilterType">
                            @for (type of totalCostFilterTypes; track type.value) {
                              <nz-option [nzLabel]="type.label" [nzValue]="type.value"></nz-option>
                            }
                          </nz-select>
                          <input class="search-box-input" [(ngModel)]="selectedTotalCostFilter"
                            name="totalCost" type="number" nz-input placeholder="Buscar..."/>
                          @if (selectedTotalCostFilterType === 11 || selectedTotalCostFilterType === 12) {
                            <input 
                              name="betweenTotalCost1" type="number" nz-input placeholder="Entre">
                            <input 
                              name="betweenTotalCost2" type="number" nz-input placeholder="Entre">
                          }
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                              [disabled]="selectedTotalCostFilter === null || !selectedTotalCostFilterType"
                              class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetTotalCostFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  }
              </th>
              }
              @else if (filter.hasSelectableFilter && filter.isVisible) {
              <th nzAlign="right">
                @if (selectedPriority.length >= 0 && filter.title === 'Prioridad') {
                <div class="priority-status-filter-container">
                  @for (priority of selectedPriority; track priority.id; let i = $index) {
                  <app-priority-tag class="selectable-tag" [backgroundColor]="priority.backgroundColor"
                    [borderColor]="priority.borderColor" [label]="priority.label" [textColor]="priority.textColor"
                    (click)="onPriorityFilterChange(priority, false)">
                  </app-priority-tag>
                  }
                </div>
                }
                @else if (selectedStatus.length >= 0 && filter.title === 'Estado') {
                <div class="priority-status-filter-container">
                  @for (state of selectedStatus; track state.id) {
                  <app-status-tag class="selectable-tag" [backgroundColor]="state.backgroundColor"
                    [borderColor]="state.borderColor" [icon]="state.icon" [label]="state.label"
                    [textColor]="state.textColor" (click)="onStatusFilterChange(state, false)">
                  </app-status-tag>
                  }
                </div>
                }
                @else if (selectedProgress.length >= 0 && filter.title === 'Proceso actual') {
                <div class="priority-status-filter-container">
                  @for (progress of selectedProgress; track progress.id) {
                  <app-status-tag class="selectable-tag" [backgroundColor]="progress.backgroundColor"
                    [borderColor]="progress.borderColor" [icon]="progress.icon" [label]="progress.label"
                    [textColor]="progress.textColor" (click)="onProgressFilterChange(progress, false)">
                  </app-status-tag>
                  }
                </div>
                }
                @else if (selectedType.length >= 0 && filter.title === 'Tipo') {
                <div class="priority-status-filter-container">
                  @for (type of selectedType; track type.id) {
                  <app-status-tag class="selectable-tag" [backgroundColor]="type.backgroundColor"
                    [borderColor]="type.borderColor" [icon]="type.icon" [label]="type.label"
                    [textColor]="type.textColor" (click)="onTypeFilterChange(type, false)">
                  </app-status-tag>
                  }
                </div>
                }
                <button nz-button nzType="text" nz-dropdown
                  [nzDropdownMenu]="filter.title === 'Prioridad' ? priorityFilterMenu
                  : (filter.title === 'Estado' ? statusFilterMenu
                  : (filter.title === 'Tipo' ? typeFilterMenu : progressFilterMenu))"
                  nzTrigger="click" nzOverlayClassName="columnsMenuDropdown">
                  <span nz-icon nzType="down" nzTheme="outline"></span>
                </button>
              </th>
              <nz-dropdown-menu #priorityFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (priority of priorityList; track priority.id; let i = $index) {
                    <li nz-menu-item (click)="onPriorityFilterChange(priority)">
                      <app-priority-tag [backgroundColor]="priority.backgroundColor" [borderColor]="priority.borderColor"
                        [label]="priority.label" [textColor]="priority.textColor"></app-priority-tag>
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>
              <nz-dropdown-menu #statusFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (state of statusList; track state.id; let i = $index) {
                  <li nz-menu-item nzType="text" (click)="onStatusFilterChange(state)">
                    <app-status-tag [backgroundColor]="state.backgroundColor" [borderColor]="state.borderColor"
                      [icon]="state.icon" [label]="state.label" [textColor]="state.textColor"></app-status-tag>
                  </li>
                  }
                </ul>
              </nz-dropdown-menu>
              <nz-dropdown-menu #typeFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (type of typesList; track type.id; let i = $index) {
                  <li nz-menu-item nzType="text" (click)="onTypeFilterChange(type)">
                    <app-status-tag [backgroundColor]="type.backgroundColor" [borderColor]="type.borderColor"
                      [icon]="type.icon" [label]="type.label" [textColor]="type.textColor"></app-status-tag>
                  </li>
                  }
                </ul>
              </nz-dropdown-menu>
              <nz-dropdown-menu #progressFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (progress of progressList; track progress.id) {
                  <li nz-menu-item nzType="text" (click)="onProgressFilterChange(progress)">
                    <app-status-tag [backgroundColor]="progress.backgroundColor" [borderColor]="progress.borderColor"
                      [icon]="progress.icon" [label]="progress.label" [textColor]="progress.textColor"></app-status-tag>
                  </li>
                  }
                </ul>
              </nz-dropdown-menu>
              }
              @else if (filter.hasDateFilter && filter.isVisible) {
                @if (filter.name === 'estimationApplicationDate' && selectedApplicationDates) {
                <th>
                  <nz-range-picker [nzAllowClear]="true" [nzShowTime]="false" [nzFormat]="'dd-MM-yy'" [nzRanges]="ranges"
                    [(ngModel)]="selectedApplicationDates.dates" (ngModelChange)="onDateFilterChange($event, filter.name)"
                    [nzPlaceHolder]="['Inicio','Fin']"></nz-range-picker>
                </th>
                }
                @else if (filter.name === 'estimationExpectedDeliveryDate' && selectedExpectedDeliveryDates) {
                <th>
                  <nz-range-picker [nzAllowClear]="true" [nzShowTime]="false" [nzFormat]="'dd-MM-yy'" [nzRanges]="ranges"
                    [(ngModel)]="selectedExpectedDeliveryDates.dates"
                    (ngModelChange)="onDateFilterChange($event, filter.name)"
                    [nzPlaceHolder]="['Inicio','Fin']"></nz-range-picker>
                </th>
                }
              }
              @else if (filter.isVisible) {
              <th></th>
              }
            }
            <ng-template #suffixIconSearch>
              <span nz-icon nzType="search" class="filter-icon"></span>
            </ng-template>
          </tr>
        </thead>
        <tbody>
          @for (data of sortTable.data; track data.estimationId; let i = $index) {
            <tr class="selectable-row" (click)="onGoToEstimationDetails(data, $event)">
              <td nzAlign="center">
                <label nz-checkbox (nzCheckedChange)="onSelectEstimation(i, $event)"
                [(ngModel)]="currentPageEstimations[i]!.isSelected"></label>
              </td>
               @if (estimationColumnsList[estimationColumnsEnum.Project].isVisible) {
                 <td>
                   <div class="info">
                     <span class="key">{{data.project.projectName}}</span>
                   </div>
                 </td>
               }
              @if (estimationColumnsList[estimationColumnsEnum.ProviderName].isVisible) {
                <td class="provider-column">{{ data.supplier.name || 'No disponible' }}</td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationFolio].isVisible) {
                <td class="folio-column">
                  {{ data.estimationFolio | number : '3.0-0': 'en-US'}}
                  @if (!currentPageEstimations[i]!.isFolioTooltipVisible) {
                    <span nz-icon nzType="link" nzTheme="outline" class="copy-icon"
                      nz-tooltip nzTooltipTitle="Copiar al portapapeles" 
                      (click)="onCopyToClipboard(data.estimationKey, i, $event)"></span>
                  }
                  @if (currentPageEstimations[i]!.isFolioTooltipVisible) {
                    <span nz-icon nzType="check-circle" nzTheme="outline" class="copied-icon"
                      nz-tooltip nzTooltipTitle="Copiado" [nzTooltipTrigger]="null"
                      [nzTooltipVisible]="currentPageEstimations[i]!.isFolioTooltipVisible"></span>
                  }
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationKey].isVisible) {
                <td class="id-column">
                  {{ data.estimationKey || 'No disponible' }}
                  @if (!currentPageEstimations[i]!.isIdTooltipVisible) {
                    <span nz-icon nzType="link" nzTheme="outline" class="copy-icon"
                      nz-tooltip nzTooltipTitle="Copiar al portapapeles" 
                      (click)="onCopyToClipboard(data.estimationKey, i, $event, true)"></span>
                  }
                  @if (currentPageEstimations[i]!.isIdTooltipVisible) {
                    <span nz-icon nzType="check-circle" nzTheme="outline" class="copied-icon"
                      nz-tooltip nzTooltipTitle="Copiado" [nzTooltipTrigger]="null"
                      [nzTooltipVisible]="currentPageEstimations[i]!.isIdTooltipVisible"></span>
                  }
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationDescription].isVisible) {
                <td>
                  <div class="description-column">
                    <div class="info">
                      <span class="description">
                        {{ data.estimationDescription | slice:0:82}}
                        {{data.estimationDescription.length > 82 ? '...' : ''}}
                      </span>
                    </div>
                    @if (data.estimationIsHighlighted) {
                    <button class="action-icon-buttons" nz-button nzType="text"
                      (click)="onHighlightEstimation(data, false, i, $event)">
                      <span nz-icon nzType="star" nzTheme="outline"></span>
                    </button>
                    }
                    @if (data.estimationNotes && data.estimationNotes !== '') {
                    <button class="action-icon-buttons" nz-button nzType="text"
                      (click)="onSelectNote(data.estimationId, $event)">
                      <img class="icon action-icon-buttons" src="assets/TwoTone.svg">
                    </button>
                    }
                  </div>
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationApplicationDate].isVisible) {
                <td nzAlign="center">
                  {{ (data.estimationApplicationDate | date: 'dd-MM-yyyy') || 'No disponible' }}
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.UserWhoRequests].isVisible) {
                <td>
                  <div class="requester-container">
                    <div class="profile-image">
                      <img
                        src="{{(data.userWhoRequests && data.userWhoRequests.img !== '')
                          ? data.userWhoRequests.img
                          : '../../../../assets/UserOutlined.svg'}}">
                    </div>
                    <div class="requester-info">
                      <span class="requester-name">{{ (data.userWhoRequests && data.userWhoRequests.name) || 'No disponible'}}</span>
                      <span>{{ (data.userWhoRequests && data.userWhoRequests.role) || 'No disponible'}}</span>
                    </div>
                  </div>
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationType].isVisible) {
                <td nzAlign="center">
                  <div class="priority-tag-container">
                    <app-status-tag [backgroundColor]="data.estimationType.backgroundColor"
                      [borderColor]="data.estimationType.borderColor" [icon]="data.estimationType.icon"
                      [label]="data.estimationType.label" [textColor]="data.estimationType.textColor"></app-status-tag>
                  </div>
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.TotalCost].isVisible) {
                <td nzAlign="right">${{data.totalCost | number : '1.2-2': 'en-US'}}</td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationPriority].isVisible) {
                <td nzAlign="center">
                  <div class="priority-tag-container">
                    <app-priority-tag [backgroundColor]="data.estimationPriority.backgroundColor"
                      [borderColor]="data.estimationPriority.borderColor" [label]="data.estimationPriority.label"
                      [textColor]="data.estimationPriority.textColor"></app-priority-tag>
                  </div>
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationStatus].isVisible) {
                <td nzAlign="center">
                  <app-status-tag [backgroundColor]="data.estimationStatus.backgroundColor"
                    [borderColor]="data.estimationStatus.borderColor" [icon]="data.estimationStatus.icon"
                    [label]="data.estimationStatus.label" [textColor]="data.estimationStatus.textColor"></app-status-tag>
                </td>
              }
              @if (estimationColumnsList[estimationColumnsEnum.EstimationProgress].isVisible) {
                <td nzAlign="center">
                  <app-status-tag [backgroundColor]="data.estimationProgress!.backgroundColor"
                    [borderColor]="data.estimationProgress!.borderColor" [icon]="data.estimationProgress!.icon"
                    [label]="data.estimationProgress!.label" [textColor]="data.estimationProgress!.textColor"></app-status-tag>
                </td>
              }
              <td>
                <button nz-button class="action-icon-buttons" nzType="text"
                  nzShape="circle" nz-dropdown (click)="blockEvent($event)"
                  [nzDropdownMenu]="actionsMenu" [nzTrigger]="'click'">
                  <span nz-icon nzType="more"></span>
                </button>
                <nz-dropdown-menu #actionsMenu="nzDropdownMenu">
                  <ul nz-menu nzSelectable>
                    @if (data.estimationIsHighlighted) {
                    <li nz-menu-item (click)="onHighlightEstimation(data, false, i, $event)">
                      <span nz-icon nzType="star" nzTheme="outline"></span>
                      Dejar de destacar
                    </li>
                    } @else {
                    <li nz-menu-item (click)="onHighlightEstimation(data, true, i, $event)">
                      <span nz-icon nzType="star" nzTheme="outline"></span>
                      Destacar
                    </li>
                    }
                    <li nz-menu-item (click)="onGoToEstimationDetails(data, $event)">
                      <span nz-icon nzType="edit" nzTheme="outline"></span>
                      Ir a detalle
                    </li>
                    @if (data.estimationNotes && data.estimationNotes !== '') {
                      @if (openedNotes.has(data.estimationId)) {
                        <li nz-menu-item (click)="onCloseNote(data.estimationId)">
                          <span nz-icon nzType="contacts" nzTheme="outline"></span>
                          Cerrar nota
                        </li>
                      } @else {
                        <li nz-menu-item (click)="onSelectNote(data.estimationId, $event)">
                          <span nz-icon nzType="contacts" nzTheme="outline"></span>
                          Ver nota
                        </li>
                      }
                    }
                    <li nz-menu-item class="delete-menu-item" (click)="onDeleteEstimation(data.estimationId, $event)">
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                      Eliminar
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
            @if (openedNotes.has(data.estimationId)) {
              <tr class="note-row">
                <td class="note-info">
                  <span>{{data.estimationNotes}}</span>
                  <button nz-button nzType="text" (click)="onCloseNote(data.estimationId)">
                    <span nz-icon nzType="close" nzTheme="outline"></span>
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </nz-table>
      <div class="table-pagination">
        <span>Total {{totalEstimations}}</span>
        @for (item of paginatorItems; track $index; let i = $index) {
        <button nz-button nzType="default" (click)="onPageIndexChange(i + 1)"
          [ngClass]="(i + 1) === currentPage ? 'highlighted' : ''"
          [disabled]="(i + 1) === currentPage">{{i + 1}}</button>
        }
        <button nz-button nzType="default" nz-dropdown nzTrigger="click" [nzDropdownMenu]="paginatorMenu">
          {{pageSize}} / página
        </button>
        <nz-dropdown-menu #paginatorMenu="nzDropdownMenu">
          <ul nz-menu>
            @for (pages of itemsPerPage; track pages) {
            <li nz-menu-item (click)="onPageSizeChange(pages)">{{pages}}</li>
            }
          </ul>
        </nz-dropdown-menu>
      </div>
      <ng-template #totalTemplate let-total>Total {{ totalEstimations }} items</ng-template>
    </nz-tab>
    }
  </nz-tabset>
  <ng-template #emptyEstimations>
    <nz-empty [nzNotFoundContent]="null" [nzNotFoundImage]="'assets/Empty.svg'">
    </nz-empty>
    <span>
      Aún no tienes estimaciones
    </span>
  </ng-template>
  <ng-template #clearAllFilters>
    <button nz-button nzType="link" (click)="onClearAllFilters()"
      [disabled]="project === undefined || appliedFilters === undefined">
      <span nz-icon nzType="clear" nzTheme="outline"></span>
      Limpiar filtros</button>
  </ng-template>
</div>